import Events from "@components/Events"
import { useRouteShellContext } from "@components/routeShellContext"
import Ship from "@components/Ship"
import { BigHeading, SiteShell } from "@components/SiteShell"
import { getCalendarEvents } from "@data/eventsData"
import * as m from "@paraglide/messages"
import type { CalendarEventsResponse } from "@site-types/calendar"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"

export const Route = createFileRoute("/$locale/calendar")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: () => getCalendarEvents(),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "calendar", path: `/${locale}/calendar` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const events = Route.useLoaderData()
  return (
    <SiteShell>
      <CalendarPage events={events} />
    </SiteShell>
  )
}

export function CalendarPage({ events }: { events: CalendarEventsResponse }) {
  const { locale } = useRouteShellContext()

  return (
    <div data-id="events-container">
      <BigHeading variant="h1">
        {(m.calendar_heading_label({}, { locale: locale }) || "Watch Now").toUpperCase()}
      </BigHeading>
      <BigHeading variant="h3">
        {m.calendar_events({}, { locale: locale }) || "Events by Playbrain"}
      </BigHeading>
      <Events {...events} />
      <Ship
        ammoBomb={m.calendar_ship_ammo_bomb({}, { locale: locale }) || "BOMB"}
        ammoLaser={m.calendar_ship_ammo_laser({}, { locale: locale }) || "LASER"}
        ammoRapid={m.calendar_ship_ammo_rapid({}, { locale: locale }) || "RAPID"}
        ammoSpread={m.calendar_ship_ammo_spread({}, { locale: locale }) || "SPREAD"}
        controls={
          m.calendar_ship_controls({}, { locale: locale }) || "← → move • SPACE / click shoot • Q E ammo"
        }
      />
    </div>
  )
}
